module.exports = __webpack_public_path__ + "static/media/microscope1.8565a0d2.jpg";